import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { authApis } from '~/api'
import { LOGIN_API } from '~/constants/APIs/auth'
import { IAuthState, ILoginForm } from '~/models'
import { setUser } from '../features/auth/authSlice'
import { PATH_NAME } from '~/constants'
import { GET_PROFILE_DETAILS_API } from '~/constants/APIs'
import { setLocaleSetting } from '../features/settings/settingSlice'

const axiosBaseQuery =
  (): BaseQueryFn<
    {
      url?: string
      method?: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
    },
    unknown,
    unknown
  > =>
    async ({ url, method, data, params, headers }) => {
      try {
        const result = await authApis.loginUser(data)

        return { data: result }
      } catch (axiosError) {
        const err = axiosError as AxiosResponse

        return {
          error: {
            status: err.status,
            data: err?.data || err
          }
        }
      }
    }

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    loginUser: builder.mutation<IAuthState, ILoginForm>({
      query: data => {
        return {
          url: LOGIN_API,
          method: 'post',
          data: data
        }
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          let result = (await queryFulfilled).data
          const userDetail = await axios.get(GET_PROFILE_DETAILS_API, {
            headers: { Authorization: `Bearer ${result.token}` }
          })
          // result.profilePictureUrl = userDetail.profilePictureUrl
          dispatch(
            setUser({
              ...result,
              profilePictureUrl: userDetail?.data?.profilePictureUrl
                ? userDetail?.data?.profilePictureUrl + `?${Math.random()}`
                : undefined
            })
          )
          dispatch(
            setLocaleSetting({ timezone: userDetail?.data?.timeZone.id, locale: userDetail?.data?.locale ?? 'en' })
          )
          if (result.errorCode === 1)
            window.location.href = PATH_NAME.PROFILE_SETTING.path
          if (result.errorCode === 2)
            window.location.href = PATH_NAME.TERMS_OF_SERVICE_PAGE.path
        } catch (error) {}
      }
    }),
    registerUser: builder.mutation({
      query: (body: {
        firstName: string
        lastName: string
        email: string
        password: string
      }) => {
        return {
          url: '/users/signup',
          method: 'post',
          body
        }
      }
    }),
    logoutUser: builder.mutation<void, void>({
      query() {
        return {
          url: '/logout',
          credentials: 'include'
        }
      }
    })
  })
})

export const { useLoginUserMutation, useRegisterUserMutation, useLogoutUserMutation } =
  authApi
